import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";

import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Card, CardBody, Container, TabContent, TabPane, Collapse, NavLink, NavItem, Nav, Row, Col, Label, Input, Button, CardTitle, Badge, ModalFooter, InputGroup, InputGroupText, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { products, } from "../../common/data/ecommerce";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { disableZone, enableZone, GetlisteZones, updateZone, UploadFileZone } from '../../services/ZonesServices/Api';
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import classnames from "classnames";
import { UpdateMemeberProfile } from "../../services/ProfileServices/Api";
import Dropzone from "react-dropzone";
import { Form } from "react-router-dom";
import config from '../../config'
import { AddAnimaux, disableAnimaux, enableAnimaux, GetlisteAnimaux, removeAnimaux, updateAnimaux, UploadFileAnimaux } from "../../services/AnimauxServices/Api";
import ReactQuill from "react-quill";
import { colors } from "../../helpers/colors";
import { AvField, AvForm } from "availity-reactstrap-validation";
import './animals-justify.css';

const optionGroup = [
    {
        options: [
            { label: "Mustard", value: "Mustard" },
            { label: "Ketchup", value: "Ketchup" },
            { label: "Relish", value: "Relish" }
        ]
    },
];

const Animals = () => {
    const [modalUpdateIsOpen, setmodalUpdateIsOpen] = useState(false)
    const [ListAnimals, setListAnimals] = useState([])
    const [User, setUser] = useState()
    const [dropdownValues, setDropdownValues] = useState({});
    const [openmodal, setopenModal] = useState(false)
    const [activeTabJustify, setactiveTabJustify] = useState("1")
    const [memberSelected, setmemberSelected] = useState()
    const [selectedCity, setselectedCity] = useState("")
    const [NameZone_FR, setNameZone_FR] = useState("")
    const [NameZone_Ar, setNameZone_Ar] = useState("")
    const [NameZone_Eng, setNameZone_Eng] = useState("")
    const [ZoneOpened, setZoneOpened] = useState({})
    const [tel, settel] = useState("")
    const [ShowConfirmModal, setShowConfirmModal] = useState(false)
    const [ShowConfirmModalII, setShowConfirmModalII] = useState(false)

    const [openedZone, setopenedZone] = useState()
    const [Latitude, setLatitude] = useState("")
    const [longitude, setlongitude] = useState("")

    const [DesZone_Fr, setDesc_Fr] = useState("")
    const [DesZone_Ar, setDesc_Ar] = useState("")
    const [DesZone_Eng, setDesc_Eng] = useState("")
    const [ZoneSelected, setZoneSelected] = useState("")

    const [adr_ferm, setadr_ferm] = useState("")
    const [Email, setEmail] = useState()
    const [DaysSelected, setDaysSelected] = useState([])
    const [openmodalevaluate, setopenmodalevaluate] = useState(false)
    const [evaluatYear, setevaluatYear] = useState('')
    const [evaluatCmnt, setevaluatCmnt] = useState('')
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [OptionZones, setOptionZones] = useState([])
    const [activeTab, setactiveTab] = useState("1")
    const [errorsizeFile, seterrorsizeFile] = useState(false)
    const [ShowConfirmRemove, setShowConfirmRemove] = useState(false)

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [paginatedData, setPaginatedData] = useState([])
    const [totalPages, setTotalPages] = useState(1)

    const handleClickMember = (member) => {
        setZoneOpened(member)
        seterrorsizeFile(false)
        setactiveTab('1')
        setLatitude(member['lat'])
        setZoneSelected({ label: member.zone['title_fr'], value: member.zone['id'] })
        setlongitude(member['lang'])
        setNameZone_FR(member['title_fr'])
        setNameZone_Ar(member['title_ar'])
        setNameZone_Eng(member['title_en'])

        setDesc_Fr(member['description_fr'])
        setDesc_Ar(member['description_ar'])
        setDesc_Eng(member['description_en'])

        setopenModal(true)
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber)
        updatePaginatedData(FilterData, pageNumber)
    }

    const updatePaginatedData = (data, page = currentPage) => {
        const totalItems = data.length
        const totalPageCount = Math.ceil(totalItems / itemsPerPage)
        setTotalPages(totalPageCount)

        const startIndex = (page - 1) * itemsPerPage
        const endIndex = Math.min(startIndex + itemsPerPage, totalItems)

        const paginatedItems = data.slice(startIndex, endIndex)
        setPaginatedData(paginatedItems)
    }

    const toggleCustomJustified = (tab) => {
        setactiveTabJustify(tab)
    }

    const handleSelectCity = async (selectedGroup) => {
        console.log(selectedGroup)
        setselectedCity(selectedGroup);
    };

    const handleClickRemove = async () => {
        await removeAnimaux(openedZone).then((res) => {
            if (res.status === 200) {
                GetData()
                setShowConfirmRemove(false)
            } else {
                toastr.error("Une erreur est survenue. Merci de réessayer plus tard.")
            }
        })
    }

    const columns = useMemo(
        () => [
            {
                Header: "Image",
                accessor: "img",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Nom",
                accessor: "title_fr",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Zone",
                accessor: "zone",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Description",
                accessor: "description_fr",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Status",
                accessor: "disable",
                disableFilters: true,
                filterable: false,
            },
        ],
    );

    if ((User?.role == 2 || User?.role == 3)) {
        columns.push({
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            filterable: false,
        })
    }

    const getZones = async () => {
        await GetlisteZones().then(res => {
            console.log(res)

            const options = res.map(item => ({
                label: item.title_fr,
                value: item.id
            }));

            const optionGroup = [
                {
                    options: options
                }
            ];
            console.log(optionGroup)
            setOptionZones(optionGroup)

        }).catch(err => {
            console.log(err)
        })
    }

    const GetData = async () => {
        await GetlisteAnimaux().then(res => {
            console.log(res)
            const filteredZones = res.filter(zone => zone.disable == false);
            setListAnimals(res)
            setsetFilterData(res)
            updatePaginatedData(res, 1) // Reset to first page when data changes
            setCurrentPage(1)
        }).catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        const Data = JSON.parse(localStorage.getItem("authUser"))
        setUser(Data)

        GetData()
        getZones()
    }, [])

    const initForm = () => {
        setSelectedFiles([])
        setNameZone_Ar("")
        setNameZone_FR("")
        setNameZone_Eng("")
        setDesc_Ar("")
        setDesc_Eng("")
        setDesc_Fr("")
        setZoneOpened({})
        setLatitude('')
        setlongitude('')
    }

    const handleAcceptedFiles = (files) => {
        const updatedFiles = files
            .filter((file) => {
                if (file.size > 50097152) {
                    seterrorsizeFile(true)
                    return false;
                }
                seterrorsizeFile(false)
                return true;
            })
            .map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    htmlFormattedSize: htmlFormatBytes(file.size),
                })
            );

        setSelectedFiles(updatedFiles);
    };

    const htmlFormatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    const handleRemoveFile = (index) => {
        setSelectedFiles(prevFiles => {
            const updatedFiles = [...prevFiles];
            updatedFiles.splice(index, 1);
            return updatedFiles;
        });
    };

    const handleupdateZone = async () => {
        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append('file', selectedFiles[0]);
            await UploadFileAnimaux(formData).then(async res => {
                console.log(res)
                ZoneOpened['lat'] = Latitude
                ZoneOpened['lang'] = longitude
                ZoneOpened['title_fr'] = NameZone_FR
                ZoneOpened['description_fr'] = DesZone_Fr
                ZoneOpened['title_ar'] = NameZone_Ar
                ZoneOpened['description_ar'] = DesZone_Ar
                ZoneOpened['title_en'] = NameZone_Eng
                ZoneOpened['description_en'] = DesZone_Eng
                ZoneOpened.zone['id'] = ZoneSelected.value
                ZoneOpened['img'] = res
                ZoneOpened['updatedAt'] = new Date()

                await updateAnimaux(ZoneOpened).then(res => {
                    console.log(res.status)
                    if (res.status === 200) {
                        toastr.success("l'animal " + NameZone_FR + " était bien modifié")
                        setopenModal(false)
                        initForm()
                        GetData()
                    } else {
                        toastr.error("Une erreur est survenue. Merci de réessayer plus tard.")
                    }
                })
            })
        } else {
            // alert(ZoneSelected.value)
            ZoneOpened['lat'] = Latitude
            ZoneOpened['lang'] = longitude
            ZoneOpened['title_fr'] = NameZone_FR
            ZoneOpened['description_fr'] = DesZone_Fr
            ZoneOpened['title_ar'] = NameZone_Ar
            ZoneOpened['description_ar'] = DesZone_Ar
            ZoneOpened['title_en'] = NameZone_Eng
            ZoneOpened['description_en'] = DesZone_Eng
            ZoneOpened.zone['id'] = ZoneSelected.value
            ZoneOpened['updatedAt'] = new Date()

            await updateAnimaux(ZoneOpened).then(res => {
                console.log(res.status)
                if (res.status === 200) {
                    toastr.success("l'animal " + NameZone_FR + " était bien modifié")
                    setopenModal(false)
                    initForm()
                    GetData()
                } else {
                    toastr.error("Une erreur est survenue. Merci de réessayer plus tard.")
                }
            })
        }
    }

    const AddAnim = async () => {
        console.log(selectedFiles[0])
        console.log(typeof (selectedFiles[0]))

        const formData = new FormData();
        formData.append('file', selectedFiles[0]);

        await UploadFileAnimaux(formData).then(async res => {
            console.log(res)

            const DataPost = {
                "description_fr": DesZone_Fr,
                "title_fr": NameZone_FR,
                "description_ar": DesZone_Ar,
                "title_ar": NameZone_Ar,
                "description_en": DesZone_Eng,
                "title_en": NameZone_Eng,
                "img": res,
                "lang": longitude,
                "lat": Latitude,
                "zone": {
                    "id": ZoneSelected.value
                }
            }
            await AddAnimaux(DataPost).then(res => {
                console.log(res.status)
                if (res.status === 201) {
                    toastr.success("l'animal " + NameZone_FR + " était bien ajouté")
                    setopenModal(false)
                    initForm()
                    GetData()
                } else {
                    toastr.error("Une erreur est survenue. Merci de réessayer plus tard.")
                }
            })
        })
    }

    const isObjectEmpty = (obj) => {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    const handleAddnewZone = () => {
        setZoneOpened({})
        initForm()
        setopenModal(true)
    }

    const handleClickDisable = async () => {
        await disableAnimaux(openedZone).then((res) => {
            if (res.status === 200) {
                GetData()
                setShowConfirmModal(false)
            } else {
                toastr.error("Une erreur est survenue. Merci de réessayer plus tard.")
            }
        })
    }

    const handleClickEnable = async (Zone) => {
        await enableAnimaux(openedZone).then((res) => {
            console.log(res)
            if (res.status === 200) {
                toastr.success("la zone était bien activé")
                GetData()
                setShowConfirmModalII(false)
            } else {
                toastr.error("Une erreur est survenue. Merci de réessayer plus tard.")
            }
        })
    }

    const handleSelectZone = (zone) => {
        setZoneSelected(zone)
    }

    const [FilterData, setsetFilterData] = useState([])
    const [searchValue, setsearchValue] = useState('')

    const handleSearch = (e) => {
        const value = e.target.value
        setsearchValue(value)

        const filtered = ListAnimals.filter(item => {
            return item.title_fr.toLowerCase().includes(value.toLowerCase()) ||
                item.description_fr.toLowerCase().includes(value.toLowerCase());
        });

        setsetFilterData(filtered);
        updatePaginatedData(filtered, 1) // Reset to first page when filter changes
        setCurrentPage(1)
    };

    // Build pagination UI
    const renderPagination = () => {
        if (totalPages <= 1) return null;

        let pages = [];

        // Previous button
        pages.push(
            <PaginationItem key="prev" disabled={currentPage === 1}>
                <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
            </PaginationItem>
        );

        // First page
        if (currentPage > 3) {
            pages.push(
                <PaginationItem key={1}>
                    <PaginationLink onClick={() => handlePageChange(1)}>
                        1
                    </PaginationLink>
                </PaginationItem>
            );
            if (currentPage > 4) {
                pages.push(<PaginationItem key="ellipsis1" disabled><PaginationLink>...</PaginationLink></PaginationItem>);
            }
        }

        // Page numbers
        for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages, currentPage + 1); i++) {
            pages.push(
                <PaginationItem key={i} active={i === currentPage}>
                    <PaginationLink onClick={() => handlePageChange(i)}>
                        {i}
                    </PaginationLink>
                </PaginationItem>
            );
        }

        // Last page
        if (currentPage < totalPages - 2) {
            if (currentPage < totalPages - 3) {
                pages.push(<PaginationItem key="ellipsis2" disabled><PaginationLink>...</PaginationLink></PaginationItem>);
            }
            pages.push(
                <PaginationItem key={totalPages}>
                    <PaginationLink onClick={() => handlePageChange(totalPages)}>
                        {totalPages}
                    </PaginationLink>
                </PaginationItem>
            );
        }

        // Next button
        pages.push(
            <PaginationItem key="next" disabled={currentPage === totalPages}>
                <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
            </PaginationItem>
        );

        return (
            <Pagination className="pagination pagination-rounded justify-content-center mb-2">
                {pages}
            </Pagination>
        );
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Listes animales"
                        breadcrumbItems={[]}
                    />

                    <Card>
                        {(User?.role == 2 || User?.role == 3) && (
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ margin: 10, width: "60%", alignItems: 'center' }}>
                                    <AvForm>
                                        <InputGroup style={{ marginBottom: 0 }}>
                                            <AvField
                                                style={{ width: 500, marginBottom: 0 }}
                                                type="text"
                                                name="search"
                                                value={searchValue}
                                                onChange={handleSearch}
                                                placeholder="Recherche..."
                                            />
                                        </InputGroup>
                                    </AvForm>
                                </div>
                                {(User?.role == 2 || User?.role == 3) && (
                                    <div className="d-flex justify-content-end m-2 mt-2">
                                        <Button color="success" onClick={handleAddnewZone}>
                                            Ajouter une animal
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}

                        <CardBody style={{ paddingBottom: '0' }}>  {/* Réduire le padding en bas */}
                            <TableContainer
                                columns={columns || []}
                                data={paginatedData || []}
                                isPagination={false}
                                iscustomPageSize={false}
                                isBordered={false}
                                customPageSize={itemsPerPage}
                                ShowPaggination={false}
                                handleClickRow={handleClickMember}
                                handleClickRemove={(Zone) => {
                                    setopenedZone(Zone.id)
                                    setShowConfirmRemove(true)
                                }}
                                handleClickDisable={(Zone) => {
                                    setopenedZone(Zone.id)
                                    setShowConfirmModal(true)
                                }}
                                handleClickEnable={(Zone) => {
                                    setopenedZone(Zone.id)
                                    setShowConfirmModalII(true)
                                }}
                                dropdownData={dropdownValues}
                                userData={User}
                            />

                            {/* Pagination component */}
                            <div className="mt-1" style={{ marginTop: '0' }}>  {/* Réduire la marge supérieure */}
                                {renderPagination()}
                            </div>
                            <div className="d-flex justify-content-center">
                                <p>Affichage de {paginatedData.length} sur {FilterData.length} animaux</p>
                            </div>
                        </CardBody>
                    </Card>

                    <Modal
                        size="xl"
                        isOpen={openmodal}
                        toggle={() => { setopenModal(false) }}
                    >
                        <ModalHeader
                            toggle={() => { setopenModal(false) }}
                            close={
                                <i className="fas fa-times" style={{ fontSize: 25, cursor: 'pointer' }} onClick={() => { setopenModal(false) }}></i>
                            }
                        >
                            Information d'animal : {ZoneOpened['title_fr']}
                        </ModalHeader>
                        <ModalBody>
                            <Row style={{ marginBottom: 20 }}>
                                <Col lg="6">
                                    <Label className="form-label" htmlFor="basicpill-firstname-input1">Image</Label>
                                    <Dropzone
                                        onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <div className="dropzone">
                                                <div className="dz-message needsclick" {...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <div className="mb-3">
                                                        <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                                    </div>
                                                    <div style={{ flexDirection: 'column', display: 'flex' }}>
                                                        <span style={{ fontSize: 14 }}>Déposez les fichiers ici ou cliquez pour télécharger.</span>
                                                        {errorsizeFile == true && (
                                                            <span style={{ fontSize: 12, fontWeight: 'bold', color: colors.red }}>Le fichier à déployer ne doit pas dépasser 2 Mo.</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                </Col>
                                <Col lg="6">
                                    {selectedFiles.some(file => file.type.startsWith('image/')) && (
                                        <div className="mt-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Row style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                {selectedFiles.filter(file => file.type.startsWith('image/')).map((file, index) => (
                                                    <Col key={index} xs="6" sm="4" md="3" lg="2">
                                                        <img
                                                            src={URL.createObjectURL(file)}
                                                            alt={file.name}
                                                            style={{ width: "190%", height: "190%", marginBottom: '10px', borderRadius: 150, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}
                                                        />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    )}
                                    {(!isObjectEmpty(ZoneOpened) && selectedFiles.length == 0) && (
                                        <div className="mt-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Row style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <Col xs="6" sm="4" md="3" lg="2">
                                                    <img
                                                        src={config.path + ZoneOpened["img"]}
                                                        alt={"icon"}
                                                        style={{ width: "190%", height: "190%", marginBottom: '10px', borderRadius: 150, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    )}

                                    {selectedFiles.length > 0 && (
                                        <Card className="mt-3">
                                            <CardBody>
                                                {selectedFiles.map((file, index) => (
                                                    <Row key={index} className="align-items-center mb-2">
                                                        <Col className="col-auto">
                                                            <h6 className="text-truncate font-size-14 mb-0">{file.name}</h6>
                                                        </Col>
                                                        <Col>
                                                            <Badge color="primary">{formatBytes(file.size)}</Badge>
                                                        </Col>
                                                        <Col className="col-auto">
                                                            <Button color="danger" size="sm" onClick={() => handleRemoveFile(index)}><i className="ri-delete-bin-2-line"></i></Button>
                                                        </Col>
                                                    </Row>
                                                ))}
                                            </CardBody>
                                        </Card>
                                    )}
                                </Col>
                            </Row>
                            <React.Fragment style={{ borderWidth: 1 }}>
                                <Row>
                                    <Col lg="4">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="basicpill-firstname-input1">Latitude</Label>
                                            <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Latitude} onChange={(e) => setLatitude(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col lg="4">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="basicpill-firstname-input1">longitude</Label>
                                            <Input type="text" className="form-control" id="basicpill-firstname-input1" value={longitude} onChange={(e) => setlongitude(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col lg="4">
                                        <div className="mb-3">
                                            <Label className="form-label">Zone</Label>
                                            <Select
                                                value={ZoneSelected}
                                                onChange={handleSelectZone}
                                                options={OptionZones}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Nav pills className="navtab-bg nav-justified mt-2">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab == "1" })}
                                            onClick={() => { setactiveTab("1") }}
                                        >
                                            Francais
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab == "2" })}
                                            onClick={() => { setactiveTab("2") }}
                                        >
                                            Arabe
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab == "3" })}
                                            onClick={() => { setactiveTab("3") }}
                                        >
                                            Englais
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1" className="p-3">
                                        <Row>
                                            <Col lg="12">
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom d'animau </Label>
                                                    <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NameZone_FR} onChange={(e) => setNameZone_FR(e.target.value)} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="12">
                                                <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                                <ReactQuill
                                                    value={DesZone_Fr}
                                                    onChange={(value) => setDesc_Fr(value)}
                                                    style={{ height: '150px' }}
                                                    theme="snow"
                                                    modules={{
                                                        toolbar: [
                                                            ['bold', 'italic', 'underline'],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                        ],
                                                    }}
                                                    formats={[
                                                        'bold', 'italic', 'underline',
                                                        'list',
                                                    ]}
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2" className="p-3">
                                        <Row>
                                            <Col lg="12">
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom d'animau</Label>
                                                    <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NameZone_Ar} onChange={(e) => setNameZone_Ar(e.target.value)} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="12">
                                                <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                                <ReactQuill
                                                    value={DesZone_Ar}
                                                    onChange={(value) => setDesc_Ar(value)}
                                                    style={{ height: '150px' }}
                                                    theme="snow"
                                                    modules={{
                                                        toolbar: [
                                                            ['bold', 'italic', 'underline'],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                        ],
                                                    }}
                                                    formats={[
                                                        'bold', 'italic', 'underline',
                                                        'list',
                                                    ]}
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3" className="p-3">
                                        <Row>
                                            <Col lg="12">
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom d'animau </Label>
                                                    <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NameZone_Eng} onChange={(e) => setNameZone_Eng(e.target.value)} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="12">
                                                <Label className="form-label" htmlFor="basicpill-address-input1">Description</Label>
                                                <ReactQuill
                                                    value={DesZone_Eng}
                                                    onChange={(value) => setDesc_Eng(value)}
                                                    style={{ height: '150px' }}
                                                    theme="snow"
                                                    modules={{
                                                        toolbar: [
                                                            ['bold', 'italic', 'underline'],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                        ],
                                                    }}
                                                    formats={[
                                                        'bold', 'italic', 'underline',
                                                        'list',
                                                    ]}
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </React.Fragment>
                        </ModalBody>
                        {!isObjectEmpty(ZoneOpened) ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 10 }}>
                                {(User?.role == 2 || User?.role == 3) && (
                                    <Button
                                        type="button"
                                        color="primary" className="waves-effect waves-light"
                                        onClick={handleupdateZone}
                                    >
                                        Mise à jour
                                    </Button>
                                )}
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 10 }}>
                                <Button
                                    type="button"
                                    color="primary" className="waves-effect waves-light"
                                    onClick={AddAnim}
                                >
                                    Enregistrer
                                </Button>
                            </div>
                        )}
                    </Modal>

                    <Modal
                        isOpen={ShowConfirmModal}
                        toggle={() => setShowConfirmModal(false)}
                        backdrop="static"
                    >
                        <ModalHeader toggle={() => setShowConfirmModal(false)}>
                            Désactiver l'animal
                        </ModalHeader>
                        <ModalBody>
                            <p>Voulez-vous désactiver cette Animal?</p>
                            <ModalFooter>
                                <Button type="button" color="light" onClick={() => setShowConfirmModal(false)}>Non</Button>
                                <Button type="button" color="primary" onClick={handleClickDisable}>Oui</Button>
                            </ModalFooter>
                        </ModalBody>
                    </Modal>

                    <Modal
                        isOpen={ShowConfirmModalII}
                        toggle={() => setShowConfirmModalII(false)}
                        backdrop="static"
                    >
                        <ModalHeader toggle={() => setShowConfirmModalII(false)}>
                            Activer l'animal
                        </ModalHeader>
                        <ModalBody>
                            <p>Voulez-vous activer cette Animal?</p>
                            <ModalFooter>
                                <Button type="button" color="light" onClick={() => setShowConfirmModalII(false)}>Non</Button>
                                <Button type="button" color="primary" onClick={handleClickEnable}>Oui</Button>
                            </ModalFooter>
                        </ModalBody>
                    </Modal>

                    <Modal
                        isOpen={ShowConfirmRemove}
                        toggle={() => setShowConfirmRemove(false)}
                        backdrop="static"
                    >
                        <ModalHeader toggle={() => setShowConfirmRemove(false)}>
                            Supprimer la Zone
                        </ModalHeader>
                        <ModalBody>
                            <p>Voulez-vous supprimer cette zone?</p>
                            <ModalFooter>
                                <Button type="button" color="light" onClick={() => setShowConfirmRemove(false)}>Non</Button>
                                <Button type="button" color="primary" onClick={handleClickRemove}>Oui</Button>
                            </ModalFooter>
                        </ModalBody>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Animals;
